import { render, staticRenderFns } from "./ShadowBtn1.vue?vue&type=template&id=7cc052aa&scoped=true"
import script from "./ShadowBtn1.vue?vue&type=script&lang=js"
export * from "./ShadowBtn1.vue?vue&type=script&lang=js"
import style0 from "./ShadowBtn1.vue?vue&type=style&index=0&id=7cc052aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cc052aa",
  null
  
)

export default component.exports